import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import { TagsWidget } from '../../../editor/features/build/requestModels/widgets/TagsWidget';

export const useTagsWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = TagsWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    update: commonWidgetHandlers.update,
    addNew,
  };
};
